import { Injectable } from "@angular/core";
@Injectable({
  providedIn: 'root',

})
export class StoreRedirectService {
  /**
   * Gets the stored redirect route from storage.
   */
  
  private StorageKeyRedirect = 'DolomitiMyredirect';

  getStoredRedirectRoute(): string {
    return localStorage.getItem(this.StorageKeyRedirect);
  }

  /**
   * Saves the redirect url to storage.
   *
   * @param url The redirect url to save.
   */
  saveStoredRedirectRoute(url: string): void {
    localStorage.setItem(this.StorageKeyRedirect, url);
  }

  /**
   * Removes the redirect url from storage.
   */
  deleteStoredRedirectRoute(): void {
    localStorage.removeItem(this.StorageKeyRedirect);
  }
}